import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoestoqueposto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoestoqueposto/FIND_ESTOQUEPOSTO':
      case '@operacaoestoqueposto/UPDATE_ESTOQUEPOSTO':
      case '@operacaoestoqueposto/DELETE_ESTOQUEPOSTO':
      case '@operacaoestoqueposto/STORE_ESTOQUEPOSTO':
      case '@operacaoestoqueposto/ESTOQUEPOSTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoestoqueposto/SUCCESS_REMOVE':
      case '@operacaoestoqueposto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoestoqueposto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoestoqueposto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@operacaoestoqueposto/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@operacaoestoqueposto/RESET_FILTERING': {
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
